import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { sentry } from '../../../../../sentry';
import { LocationSectorApi } from '../../../../core/api/location-sectors/location-sectors.api';
import { AuthenticationService } from '../../../../core/authentication/authentication.service';
import { CustomMessagesService } from '../../../../core/errors/custom-messages.service';
import { locationSectorNameUniqueAsyncValidator } from './dialog-location-sector.validator';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DialogLocationSectorComponent = /** @class */ (function () {
    function DialogLocationSectorComponent(data, formBuilder, translationLoader, locationSectorApi, messageService, matDialogRef, authenticationService) {
        this.data = data;
        this.formBuilder = formBuilder;
        this.translationLoader = translationLoader;
        this.locationSectorApi = locationSectorApi;
        this.messageService = messageService;
        this.matDialogRef = matDialogRef;
        this.authenticationService = authenticationService;
        this.isUpdate = false;
        this.isLoading = false;
        this.isViewMode = !this.authenticationService.hasPermission('locations-edit');
        this.translationLoader.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogLocationSectorComponent.prototype.ngOnInit = function () {
        this.locationSectorForm = this.formBuilder.group({
            name: new FormControl(this.data.locationSector.name, {
                validators: [Validators.required, Validators.maxLength(100)],
                asyncValidators: [
                    locationSectorNameUniqueAsyncValidator({
                        sectorId: this.data.locationSector.id,
                        locationId: this.data.locationSector.location.id,
                        locationSectorApi: this.locationSectorApi
                    })
                ]
            }),
            location: new FormControl(this.data.locationSector.location, [Validators.required]),
            description: [this.data.locationSector.description, [Validators.maxLength(2000)]]
        });
        this.locationSectorForm.get('location').disable();
        if (this.isViewMode) {
            this.locationSectorForm.disable();
        }
    };
    DialogLocationSectorComponent.prototype.saveLocationSector = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, _a, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        this.isLoading = true;
                        if (!this.data.locationSector.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.locationSectorApi.update(this.prepareUpdateInput())];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.locationSectorApi.create(this.prepareCreateInput())];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        result = _a;
                        this.messageService.success('LOCATION_SECTOR_DIALOG.MESSAGE.SUCCESS');
                        this.matDialogRef.close({
                            reload: true,
                            locationSector: result
                        });
                        return [3 /*break*/, 7];
                    case 5:
                        error_1 = _b.sent();
                        console.error(error_1);
                        sentry.captureException(error_1);
                        this.messageService.error(error_1);
                        return [3 /*break*/, 7];
                    case 6:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DialogLocationSectorComponent.prototype.prepareCreateInput = function () {
        var form = this.locationSectorForm.getRawValue();
        return {
            name: form.name,
            description: form.description,
            locationId: this.data.locationSector.location.id
        };
    };
    DialogLocationSectorComponent.prototype.prepareUpdateInput = function () {
        var form = this.locationSectorForm.getRawValue();
        return {
            id: this.data.locationSector.id,
            name: form.name,
            description: form.description,
        };
    };
    return DialogLocationSectorComponent;
}());
export { DialogLocationSectorComponent };
